import { useState } from "react";
import { motion } from "framer-motion";

interface QuestionAgeProps {
  onNext: () => void;
  onBack?: () => void;
  onSelect: (value: string) => void;
  selected: string;
  showBadge?: boolean;
}

const ageOptions = ["25–35", "35–45", "45–55", "55–65", "65–75", "75–85", "85–95"];

const QuestionAge = ({ onNext, onBack, onSelect, selected, showBadge = false }: QuestionAgeProps) => {
  const [justSelected, setJustSelected] = useState<string | null>(null);

  const handleSelect = (value: string) => {
    onSelect(value);
    setJustSelected(value);
    setTimeout(() => onNext(), 700);
  };

  return (
    <div>
      {onBack && (
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
        >
          <span className="text-xl">←</span> Terug
        </button>
      )}

      <div className="text-center">
        {showBadge && (
          <div className="mb-4">
            <span className="inline-block bg-accent/15 text-accent font-sans text-[15px] font-bold uppercase tracking-wider px-4 py-1.5 rounded-full">
              Ontvang €60 korting
            </span>
          </div>
        )}

        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-2 leading-tight">
          In welke leeftijdscategorie val je?
        </h2>
        <p className="text-foreground/80 font-sans text-lg mb-6 md:mb-10">
          Ontdek in 2 minuten jouw persoonlijk huidadvies
        </p>

        <div className="grid gap-3">
          {ageOptions.map((age, i) => (
            <motion.button
              key={age}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
              onClick={() => handleSelect(age)}
              className={`quiz-option min-w-[90px] text-center ${
                (selected === age || justSelected === age) ? "quiz-option-selected" : ""
              }`}
            >
              <span className="text-foreground font-semibold text-xl">{age}</span>
              {justSelected === age && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="ml-2 text-primary font-bold"
                >
                  ✓
                </motion.span>
              )}
            </motion.button>
          ))}
        </div>

        <p className="text-[13px] text-foreground/40 text-center mt-6 leading-snug max-w-sm mx-auto">
          Door op een van de bovenstaande opties te klikken, ga je akkoord met de{" "}
          <a href="https://adelira.nl/pages/gebruiksaanwijzing-ifu" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground/60">Gebruiksvoorwaarden</a>,{" "}
          <a href="https://adelira.nl/policies/terms-of-service" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground/60">Servicevoorwaarden</a> en het{" "}
          <a href="https://adelira.nl/policies/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground/60">Privacybeleid</a>.
        </p>
      </div>
    </div>
  );
};

export default QuestionAge;
